/**
 * The category of the ASBV to allow grouping the results.
 */
export enum ASBVCategory {
  All = 0,
  Default = 1,
}
